/**
 * @generated SignedSource<<845ff25dd8e9fe93d6764355f88c3493>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteCustomFieldDropdownOptionInput = {
  customFieldDefinitionId: string;
  optionId: string;
  replacementOptionId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteCustomFieldDropdownOptionMutation$variables = {
  input: DeleteCustomFieldDropdownOptionInput;
};
export type DeleteCustomFieldDropdownOptionMutation$data = {
  readonly deleteCustomFieldDropdownOption: {
    readonly deletedOptionId: string | null;
    readonly replacementOptionId: string | null;
  } | null;
};
export type DeleteCustomFieldDropdownOptionMutation$rawResponse = {
  readonly deleteCustomFieldDropdownOption: {
    readonly deletedOptionId: string | null;
    readonly replacementOptionId: string | null;
  } | null;
};
export type DeleteCustomFieldDropdownOptionMutation = {
  variables: DeleteCustomFieldDropdownOptionMutation$variables;
  response: DeleteCustomFieldDropdownOptionMutation$data;
  rawResponse: DeleteCustomFieldDropdownOptionMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteCustomFieldDropdownOptionPayload",
    "kind": "LinkedField",
    "name": "deleteCustomFieldDropdownOption",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedOptionId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replacementOptionId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteCustomFieldDropdownOptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteCustomFieldDropdownOptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "96938efa4e969c6af28aff9a3309817a",
    "id": null,
    "metadata": {},
    "name": "DeleteCustomFieldDropdownOptionMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteCustomFieldDropdownOptionMutation(\n  $input: DeleteCustomFieldDropdownOptionInput!\n) {\n  deleteCustomFieldDropdownOption(input: $input) {\n    deletedOptionId\n    replacementOptionId\n  }\n}\n"
  }
};
})();

(node as any).hash = "3fce4e76f775e06faa608399ab096651";

export default node;
